import {Directive, Input} from '@angular/core';
import {CopyTooltipDirective} from '../copy-tooltip/copy-tooltip.directive';
import {CopyTxExploreTooltipBalloonComponent} from './copy-tx-explore-tooltip-balloon.component';

@Directive({
    selector:   '[copyTxExploreTooltip]',
    standalone: false
})
export class CopyTxExploreTooltipDirective extends CopyTooltipDirective {

    @Input('copyTxExploreTooltip')
    public override copyTooltip: string;

    protected override readonly balloonClass = CopyTxExploreTooltipBalloonComponent;

}
